import { Button, Card, Col, Input, Popconfirm, Row, Space, Table, TableColumnsType } from "antd";
import React from "react";
import Title from "antd/lib/typography/Title";
import { VolumeTierLine } from "../interfeces";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { useEditServiceContext } from "components/ratecard/contextProviders";
import { TableComponents } from "rc-table/lib/interface";

interface ValumeTierProps {
  item: VolumeTierLine;
  deletable: boolean;
  disabled: boolean;
  remarkErrors: boolean;
  index: number;
  weightTier: number;
  components:
    | TableComponents<{
        deletable: boolean;
        key: number;
        weight_tier: number;
        volume_tier: number;
      }>
    | undefined;
  columns:
    | (
        | {
            title: string;
            dataIndex: string;
            key: string;
            editable?: undefined;
            width?: undefined;
            className?: undefined;
            required?: undefined;
            render?: undefined;
          }
        | {
            title: string;
            dataIndex: string;
            key: string;
            editable: boolean;
            width: string;
            className: string;
            required: boolean;
            render?: undefined;
          }
        | {
            dataIndex: string;
            render: (
              _: any,
              record: {
                deletable: boolean;
                key: number;
                weight_tier: number;
                volume_tier: number;
              }
            ) => JSX.Element | null;
            title?: undefined;
            key?: undefined;
            editable?: undefined;
            width?: undefined;
            className?: undefined;
            required?: undefined;
          }
      )[]
    | TableColumnsType<any>
    | undefined;
  handleDeteleVolumeTier: (weightTier: number, volumeTier: number) => void;
  handleOnChangeTierThreshold: (value: string, weightKey: number, tierKey: number) => void;
  handleUpdateVolumeTier: (weightTier: number, volumeTier: number) => void;
  handleAddTableTier: (weightTier: number, volumeTier: number) => void;
  getDataSource: (
    weightTier: number,
    volumeTier: number
  ) => {
    key: number;
    from: number;
    to: string;
    price: number;
    weight_tier: number;
    volume_tier: number;
    deletable: boolean;
  }[];
}

const VolumeTier: React.FC<ValumeTierProps> = ({
  item,
  deletable,
  disabled,
  remarkErrors,
  index,
  weightTier,
  components,
  columns,
  handleDeteleVolumeTier,
  handleOnChangeTierThreshold,
  handleUpdateVolumeTier,
  handleAddTableTier,
  getDataSource,
}: ValumeTierProps) => {
  const { allowEditing } = useEditServiceContext();
  return (
    <Col span={12} style={{ marginBottom: "20px" }}>
      <Card>
        <Row>
          <Col span={10} />
          <Col span={13}>
            <Title level={3}>Tier {index + 1}</Title>
          </Col>
          <Col span={1}>
            <Row justify="center">
              {deletable && (
                <Popconfirm
                  title="This will delete all the pick tiers for this volume tier, are you sure?"
                  onConfirm={() => handleDeteleVolumeTier(weightTier, item.key)}
                >
                  <Button icon={<DeleteOutlined />} size="large" />
                </Popconfirm>
              )}
            </Row>
          </Col>
        </Row>
        <Space direction="vertical" size="large" style={{ width: "100%" }}>
          <Row>
            <Col span={3} />
            <Col span={18}>
              <Row>Tier Threshold</Row>
              <Row gutter={24}>
                <Col span={12}>
                  <Input value={item.from} disabled={true} />
                </Col>
                <Col span={12}>
                  <Input
                    placeholder={item.to}
                    value={item.to}
                    className={remarkErrors ? "change-needed" : ""}
                    disabled={disabled}
                    onChange={(e) => handleOnChangeTierThreshold(e.target.value, weightTier, item.key)}
                    onBlur={() => {
                      handleUpdateVolumeTier(weightTier, item.key);
                    }}
                    onPressEnter={() => {
                      handleUpdateVolumeTier(weightTier, item.key);
                    }}
                    type="number"
                  />
                </Col>
              </Row>
            </Col>
            <Col span={3} />
          </Row>
          <Row>
            <Col span={18} />
            <Col span={5}>
              {allowEditing && (
                <Button
                  type="link"
                  icon={<PlusOutlined />}
                  size="small"
                  onClick={() => handleAddTableTier(weightTier, item.key)}
                >
                  Add Pick Tier
                </Button>
              )}
            </Col>
            <Col span={1} />
          </Row>
        </Space>
        <Row>
          <Col span={1} />
          <Col span={23}>
            <Table
              components={components}
              pagination={false}
              dataSource={getDataSource(weightTier, item.key)}
              columns={columns}
            />
          </Col>
        </Row>
      </Card>
    </Col>
  );
};

export default VolumeTier;
